export default __webpack_public_path__ + "static/media/product-image-hover-17.1d9fdf8b.jpg";